import { useMemo } from 'react'

const { userSettingsModule } = require('utils/utils')

const hasOperation = (operation, key = 'operations') => {
   const isOperationFound = userSettingsModule.buscarValorEnUserSettings(key, operation?.code || operation)
   return isOperationFound
}

export const useHasOperation = (operation, key = 'operations') => {
   return useMemo(() => hasOperation(operation, key), [])
}
